import { NgModule } from "@angular/core";
import { CommunityRoutingModule } from "./community-routing.module";
import { PostItemContainerComponent } from "./pages/post-item-container/post-item-container.component";
import { PostItemViewComponent } from "./pages/post-item-view/post-item-view.component";
import { CommonModule } from "@angular/common";
import { PostItemDetailComponent } from "./pages/post-item-detail/post-item-detail.component";
import { SharedModule } from '@app/shared';
import { FeedsDetailComponent } from './pages/feeds-detail/feeds-detail.component';
import { ShareUpdateComponent } from './pages/share-update/share-update.component';
import { PostReferralComponent } from './pages/post-referral/post-referral.component';
import { CommunityLayoutComponent } from './layout/community-layout/community-layout.component';
import { TrendingPostsComponent } from './pages/trending-posts/trending-posts.component';
import { NgxLinkifyjsModule } from 'ngx-linkifyjs';

@NgModule({
  declarations: [
    PostItemContainerComponent,
    PostItemViewComponent,
    PostItemDetailComponent,
    FeedsDetailComponent,
    ShareUpdateComponent,
    PostReferralComponent,
    CommunityLayoutComponent,
    TrendingPostsComponent
  ],
  entryComponents: [ShareUpdateComponent, PostReferralComponent],
  imports: [CommunityRoutingModule, CommonModule, SharedModule, NgxLinkifyjsModule],
  providers: [],
})
export class CommunityModule { }
